import { useEffect, useRef, useState } from "react";
import { Box, IconButton, Slider, Typography } from "@mui/material";
import PlayArrowRounded from "@mui/icons-material/PlayArrowRounded";
import PauseRounded from "@mui/icons-material/PauseRounded";

export default function AudioMessage({ src }) {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [current, setCurrent] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const audio = ref.current;
    if (!audio) return;
    const onTime = () => setCurrent(audio.currentTime);
    const onLoaded = () => setDuration(audio.duration || 0);
    const onEnd = () => {
      setPlaying(false);
      setCurrent(0);
    };
    audio.addEventListener("timeupdate", onTime);
    audio.addEventListener("loadedmetadata", onLoaded);
    audio.addEventListener("ended", onEnd);
    return () => {
      audio.removeEventListener("timeupdate", onTime);
      audio.removeEventListener("loadedmetadata", onLoaded);
      audio.removeEventListener("ended", onEnd);
    };
  }, []);

  const toggle = () => {
    const a = ref.current;
    if (playing) a.pause();
    else a.play();
    setPlaying(!playing);
  };

  const fmt = (s) => {
    if (!s || isNaN(s)) return "0:00";
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${sec}`;
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 220 }}>
      <audio ref={ref} src={src} preload="metadata" />
      <IconButton size="small" onClick={toggle}>
        {playing ? <PauseRounded /> : <PlayArrowRounded />}
      </IconButton>
      <Slider
        size="small"
        min={0}
        max={duration || 1}
        value={Math.min(current, duration || 1)}
        onChange={(_, v) => {
          ref.current.currentTime = v;
          setCurrent(v);
        }}
        sx={{ flex: 1 }}
      />
      <Typography sx={{ fontSize: 11, minWidth: 32, textAlign: "right" }}>
        {current > 0 ? fmt(current) : fmt(duration)}
      </Typography>
    </Box>
  );
}
